import './App.css'
import React, { useEffect, useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './bootstrap.min.css'
import './common.scss'
import Layout from './components/Layout'
import { PATH } from './constants/router'
import { AppParamsContextProvider, useAppParamsContext } from './context/AppParamsContext'
import { AppUserContextProvider } from './context/AppUserContext'
import AppUserRouteGuard from './context/AppUserRouteGuard'
import { TrafficFineVehicleContextProvider } from './context/TrafficFineVehicleContext'
import LoadingScreen from './components/BasicComponent/LoadingScreen'
import { ROUTERS } from './router'
import { fetchMetadataWithCache } from './helper/metadataCache'
import { PRELOAD_IMAGE_ASSETS } from './constants/preloadImages'
import usePreloadImages from './hooks/common/usePreloadImages'
export const baseName = '/'

const AppInitializer = () => {
  const { appThemeName } = useAppParamsContext()

  useLayoutEffect(() => {
    if (appThemeName) {
      document.body.setAttribute('data-theme', String(appThemeName).toUpperCase())
    } else {
      document.body.removeAttribute('data-theme')
    }

    const loadingScreen = document.querySelector('.splash-screen-loading')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  }, [appThemeName])

  return null
}

function App() {
  usePreloadImages(PRELOAD_IMAGE_ASSETS)

  useEffect(() => {
    fetchMetadataWithCache().catch(() => null)
  }, [])

  return (
    <AppParamsContextProvider>
      <AppInitializer />
      <AppUserContextProvider>
        <TrafficFineVehicleContextProvider>
          <Router basename={baseName}>
            <AppUserRouteGuard />
            <Switch>
              {Object.keys(ROUTERS).map((key) => {
                return (
                  <Route
                    key={ROUTERS[key].path || key}
                    exact
                    path={ROUTERS[key].path}
                    component={(props) => (
                      <React.Suspense fallback={<LoadingScreen open statusLabel="Đang tải ứng dụng" />}>
                        <Layout {...props} Component={ROUTERS[key].component} hideMobileMenu={ROUTERS[key].hideMobileMenu} />
                      </React.Suspense>
                    )}
                  />
                )
              })}
              <Redirect to={PATH.HOME} />
            </Switch>
          </Router>
        </TrafficFineVehicleContextProvider>
      </AppUserContextProvider>
    </AppParamsContextProvider>
  )
}

export default App
